import { createAsyncThunk } from '@reduxjs/toolkit'
import MarketingMetric from './marketing-metric-model'
import {
  delete_marketingMetric,
  load_marketingMetrics,
  store_marketingMetric,
} from './marketingMetric-service'

export const LoadMarketingMetricsAsync = createAsyncThunk<any, any>(
  'composer/load/marketingMetric',
  async (params: { uid: string }) => {
    return await load_marketingMetrics(params)
  },
)

export const CreateMarketingMetricAsync = createAsyncThunk<any, any>(
  'composer/create/marketingMetric',
  async (params: MarketingMetric) => {
    return await store_marketingMetric(params)
  },
)

export const DeleteMarketingMetricAsync = createAsyncThunk<any, any>(
  'composer/delete/marketingMetric',
  async (params) => {
    return await delete_marketingMetric(params)
  },
)
